// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner_root__DEtr7"};